export default {
  DEFAULT: 'default',
  WARNING: 'warning',
  DANGER: 'danger',
  EXTREME: 'extreme',
};
